import React, { useState } from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export default function SettingsConfirmDialog({
  open,
  onOpenChange,
  title,
  description,
  consequences,
  confirmLabel = 'Conferma',
  cancelLabel = 'Annulla',
  onConfirm,
  destructive = false,
}) {
  const [saving, setSaving] = useState(false);

  const confirm = async () => {
    setSaving(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={saving ? undefined : onOpenChange}>
      <AlertDialogContent data-testid="settings-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        {consequences && <div className="rounded-lg bg-stone-50 p-3 text-sm text-stone-600">{consequences}</div>}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={saving}>{cancelLabel}</AlertDialogCancel>
          <AlertDialogAction
            disabled={saving}
            onClick={(event) => {
              event.preventDefault();
              confirm().catch(() => {});
            }}
            className={destructive ? 'bg-red-600 hover:bg-red-700' : ''}
          >
            {saving ? 'Attendi…' : confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}